




import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";

import PackingBarCode from "./components/PackingBarCode.vue";
@Component({
  components: {
    PackingBarCode,
  }
})
export default class PackingScreenCockpit extends Vue {
  private timer1: any = null;
  private curDate: any = null;
  private moment: any = moment; // 时间格式

  mounted() {
    const that: any = this;
    this.timer1 = setInterval(() => {
      that.curDate = that.moment(new Date()).format("YYYY/MM/DD 周dd HH:mm:ss");
    }, 1000);
  }

  destroyed () {
    clearInterval(this.timer1);
  }
}
